module.exports = __webpack_public_path__ + "img/Vector_11.fdfbd274.png";